export default __webpack_public_path__ + "static/media/txt_series1.4b8eb487.svg";